import CouponMarketplacePopup from './coupon-marketplace-popup-view'

export default CouponMarketplacePopup
